import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Data extends SelfServiceAPI.CreateGuestAmendment.Request {
  bookingId: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const createGuestAmendment = async (
  { bookingId, email, phoneNumber, qffNumber, businessNumber }: Data,
  options: Options = {},
): Promise<SelfServiceAPI.CreateGuestAmendment.Response> => {
  try {
    const { data } = await axios.post<SelfServiceAPI.CreateGuestAmendment.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/guest-amendment`,
      { email, phoneNumber, qffNumber, businessNumber },
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await createGuestAmendment({ bookingId, email, phoneNumber, qffNumber, businessNumber }, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/guest-amendment`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createGuestAmendment;
